// extracted by mini-css-extract-plugin
module.exports = {"companions":"companions-382QT","description":"description-3J0i0"};